<template>
  <div>
    <transition name="fade-slide">
      <div v-if="showDeleteSuccess" class="success-toast" role="status">
        <img src="@/assets/mdi_success-bold.svg" alt="img" width="20" height="20" />
        <span style="font-size: 14px; font-weight: 600;">{{ deleteSuccessMessage }}</span>
      </div>
    </transition>
    <v-container fluid>
      <!-- <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" dark class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">Intent Group</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader> -->
      
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center" style="margin-top: -20px;">
            <v-col cols="12" md="6">
              <h2 style="font-weight: 600; color: #171717;">Intent Group List</h2>
            </v-col>
            <v-col cols="6" class="d-flex flex-wrap justify-end gap-2">
              <v-row align="center" justify="end" style="gap: 20px;">
                <v-text-field
                  v-model="searchName"
                  placeholder="Intent Group Name"
                  hide-details
                  variant="plain"
                  class="search-input"
                  density="comfortable"
                  @input="onSearchInput"
                  @click:clear="clearSearch"
                >
                  <template #prepend-inner>
                    <img
                      class="search-icon"
                      src="@/assets/flowbite_search-outline.svg"
                      alt="Search"
                      width="20"
                      height="20"
                    />
                  </template>
                </v-text-field>
                <v-tooltip location="top" max-width="230px">
                  <template v-slot:activator="{ props }">
                    <button
                      v-bind="props"
                      id="button-add-intentgroup"
                      type="button"
                      class="products-header-button"
                      variant="elevated"
                      size="large"
                      rounded="xl"
                      @click="Add()"
                    >
                      <img src="@/assets/ic_round-plus.svg" alt="img" width="20" height="20" />
                      <span style="color: #ffffff; font-size: 14px;">{{ $t("add") }}</span>
                    </button>
                  </template>
                  <span>Add new Intent Group</span>
                </v-tooltip>
              </v-row>

              <!-- <v-card variant="outlined" class="pa-2 search-panel">
                <v-row no-gutters>
                  <v-col cols="9" class="pa-2">
                    <v-text-field
                      id="input-search-groupname-intentgroup"
                      label="Intent Group Name"
                      v-model="searchName"
                      @keydown.enter="Search"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-clipboard-text-search-outline"
                      hide-details
                      clearable
                      color="primary"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="pa-2 d-flex align-center justify-end">
                    <v-btn
                      id="button-search-gptmodelmanagement"
                      color="primary"
                      class="ml-2"
                      variant="elevated"
                      @click="Search"
                    >
                      <v-icon start>mdi-magnify</v-icon>
                      {{ $t("search") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card> -->
            </v-col>
            <!-- <v-col cols="12" sm="6" class="d-flex flex-wrap justify-end gap-2">
              <v-btn
                id="button-add-intentgroup"
                color="primary"
                class="control-btn create-btn"
                variant="elevated"
                size="large"
                prepend-icon="mdi-plus-circle"
                rounded="xl"
                @click="Add()"
              >
                <span class="btn-text">{{ $t("add") }}</span>
              </v-btn>
            </v-col> -->
          </v-row>
        </v-card-text>
        <v-data-table-server
          v-model:options="options"
          :items-per-page="itemsPerPage"
          :items-length="searchTotalTable"
          :items="dataTable"
          :headers="headers"
          :loading="loadingTable"
          class="pa-4"
        >
          <template #no-data>
            <div style="text-align: center;">
              <span style="color: #646464; font-weight: 400;">No Data Available</span>
            </div>
          </template>
          <template v-slot:bottom>
            <div
              class="d-flex justify-space-between align-center px-4 py-2"
              style="width: 100%"
            >
              <div>Total results {{ searchTotalTable }}</div>

              <v-data-table-footer
                :items="[
                  { text: '10', value: 10 },
                  { text: '25', value: 25 },
                  { text: '50', value: 50 },
                  { text: '100', value: 100 },
                  { text: 'All', value: -1 },
                ]"
                :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)"
              />
            </div>
          </template>
          <!-- <template #bottom>
            <div class="table-footer-bar" style="display: flex; justify-content: space-between; align-items: center; padding: 8px 16px;">
              <div class="footer-left">
                <span class="total-label" style="color: #171717; font-size: 13px;">Total results {{ searchTotalTable }}</span>
              </div>
              <div class="footer-center" style="display: flex; align-items: center; gap: 16px;">
                <span class="per-page-label" style="color: #171717; font-size: 13px;">Items per page</span>
                <v-select
                  v-model="options.itemsPerPage"
                  :items="[
                    { text: '10', value: 10 },
                    { text: '25', value: 25 },
                    { text: '50', value: 50 },
                    { text: '100', value: 100 },
                    { text: 'All', value: -1 },
                  ]"
                  item-title="text"
                  item-value="value"
                  hide-details
                  variant="outlined"
                  density="compact"
                  :menu-icon="null"
                  class="items-select small-select"
                  style="width:84px"
                >
                  <template #append-inner>
                    <img class="dropdown-icon" src="@/assets/iconamoon_arrow-up-2-light.svg" alt="toggle" />
                  </template>
                </v-select>
                <span class="range-label" style="margin-left: 12px;">
                  {{ rangeStart }}-{{ rangeEnd }} of {{ totalPages }}
                </span>
                <div class="nav-buttons" style="display: flex; gap: 4px;">
                  <v-btn variant="text" density="comfortable" class="nav-btn" :disabled="options.page===1" @click="options.page = Math.max(1, options.page-1)">
                    <img src="@/assets/left-arrow.svg" alt="icon" width="20" height="20" />
                  </v-btn>
                  <v-btn variant="text" density="comfortable" class="nav-btn" :disabled="options.page >= totalPages" @click="options.page = Math.min(totalPages, options.page+1)">
                    <img src="@/assets/iconamoon_arrow-left-2-light.svg" alt="icon" width="20" height="20" />
                  </v-btn>
                </div>
              </div>
            </div>
          </template> -->

          <template v-slot:item="{ item }">
            <tr style="color: #000000; font-weight: 500; font-size: 13px;">
              <td style="text-align: left">{{ item.number }}</td>
              <td>{{ item.name }}</td>
              <td>{{ substring(item.intentSessionName) }}</td>
              <td style="text-align: left">{{ item.createBy }}</td>
              <td style="text-align: left">
                <div class="action-group" style="justify-content: center;">
                  <!-- Edit -->
                  <v-btn
                    id="button-edit-intentgroup" 
                    variant="text"
                    density="comfortable"
                    @click="Edit(item)"
                    icon
                  >
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/Edit.svg"
                          alt="img"
                          width="20"
                          height="20"
                          style="cursor: pointer; margin-left: 4px;"
                        />
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                    <!-- <v-icon size="18">mdi-pencil-outline</v-icon> -->
                    <!-- <v-tooltip activator="parent" location="top">
                      Edit
                    </v-tooltip> -->
                  </v-btn>
                  <!-- Custom Divider -->

                  <!-- <div class="action-divider"></div> -->
                  
                  <!-- Delete -->
                  <v-btn
                    id="button-delete-intentgroup"
                    variant="text"
                    density="comfortable"
                    @click="openDeleteDialog(item)"
                    icon
                    :disabled="btnDisableDelete(item)"
                  >
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/Group.svg"
                          alt="img"
                          width="20"
                          height="17"
                          style="cursor: pointer; margin-left: 4px;"
                        />
                      </template>
                      <span>Delete</span>
                    </v-tooltip>
                    <!-- <v-icon size="18">mdi-delete-outline</v-icon> -->
                    <!-- <v-tooltip location="top">
                      Delete
                    </v-tooltip> -->
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table-server>

        <v-dialog v-model="showDeleteDialog" max-width="570">
          <v-card class="delete-dialog-card">
            <v-card-title class="card-dialog-title" style="background-color: #FFF2F2;">
              <span class="dialog-title font-weight-bold">Delete Intent Group</span>
              <v-btn icon variant="text" density="comfortable" @click="closeDeleteDialog">
                <img src="@/assets/Vector.svg" alt="icon" width="12" height="12">
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-6 pb-4 px-4 body-text">
              Are you sure you want to delete this product group? This action
              cannot be undone.
            </v-card-text>
            <hr style="border: none; border-top: 1px solid #c9c9c9;" />
            <v-card-actions class="px-6 pb-3 pt-3 pl-8 justify-end" style="gap: 12px;">
              <button type="button" class="cancel-btn" @click="closeDeleteDialog" :disabled="deleting">Cancel</button>
              <v-btn class="delete-confirm-btn" :loading="deleting" @click="Delete(item.intentGroupID)">
                <img src="@/assets/heroicons_trash-solid.svg" alt="img" width="17" height="22" class="mr-2">
                <p style="color: #ffffff; font-size: 11px; font-weight: 500;">Delete</p>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-card>
    </v-container>
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
    <!-- Edit -->
    <v-dialog v-model="EditIntentGroup" max-width="1000">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ $t("edit") }}
        </v-card-title>
        <v-card-text style="margin-top: 1rem">
          <v-row>
            <v-col cols="12" sm="12" md="4">
              <v-text-field
                id="groupintentname-edit-intentgroup"
                :label="$t('groupIntentName')"
                v-model="GroupIntent.Name"
                :rules="[rules.required]"
                required
                outlined
                dense
              >
                <template v-slot:append-outer>
                  <v-tooltip location="top" max-width="300">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        text
                        x-small
                        style="position: absolute; top: 0px; right: -6px"
                        v-bind="props"
                        >mdi-information-outline</v-icon
                      >
                    </template>
                    <span>{{ $t("_InfoGroupModelName") }}</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row style="margin-top: 0">
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                id="edit-model-intentgroup"
                :label="$t('model')"
                v-model="GroupIntent.IntentSession"
                :items="DDIntentSession"
                item-title="name"
                item-value="id"
                chips
                clearable
                deletable-chips
                multiple
                outlined
              >
                <template v-slot:append-outer>
                  <v-tooltip location="top" max-width="300">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        text
                        x-small
                        style="position: absolute; top: 0px; right: -6px"
                        v-bind="props"
                        >mdi-information-outline</v-icon
                      >
                    </template>
                    <span>{{ $t("_InfoModelinGroup") }}</span>
                  </v-tooltip>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="button-close-edit-intentgroup"
            color="blue darken-1"
            variant="text"
            @click="EditIntentGroup = false"
            >{{ $t("close") }}</v-btn
          >
          <v-btn
            id="button-save-edit-intentgroup"
            color="blue darken-1"
            variant="text"
            @click="Save()"
            >{{ $t("save") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Add -->
    <v-dialog v-model="AddIntentGroup" max-width="1000">
      <v-card>
        <v-card-title
          class="text-h5 grey lighten-2"
          style="position: sticky; top: 0px"
        >
          {{ $t("add") }}
        </v-card-title>
        <v-card-text style="margin-top: 1rem">
          <v-row>
            <v-col cols="12" sm="12" md="4">
              <v-text-field
                id="groupintentname-add-intentgroup"
                :label="$t('groupIntentName')"
                v-model="GroupIntent.Name"
                :rules="[rules.required]"
                required
                outlined
                dense
              >
                <template v-slot:append-outer>
                  <v-tooltip location="top" max-width="300">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        text
                        x-small
                        style="position: absolute; top: 0px; right: -6px"
                        v-bind="props"
                        >mdi-information-outline</v-icon
                      >
                    </template>
                    <span>{{ $t("_InfoGroupModelName") }}</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row style="margin-top: 0;">
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                id="add-model-intentgroup"
                :label="$t('model')"
                v-model="GroupIntent.IntentSession"
                :items="DDIntentSession"
                item-text="name"
                item-value="id"
                chips
                clearable
                deletable-chips
                multiple
                outlined
                :rules="[rules.required]"
                required
                dense
              >
                <template v-slot:append-outer>
                  <v-tooltip location="top" max-width="300">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        text
                        x-small
                        style="position: absolute; top: 0px; right: -6px"
                        v-bind="props"
                        >mdi-information-outline</v-icon
                      >
                    </template>
                    <span>{{ $t("_InfoModelinGroup") }}</span>
                  </v-tooltip>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="button-close-add-intentgroup"
            color="blue darken-1"
            variant="text"
            @click="AddIntentGroup = false"
            >{{ $t("close") }}</v-btn
          >
          <v-btn
            id="button-save-add-intentgroup"
            color="blue darken-1"
            variant="text"
            @click="Save()"
            >{{ $t("save") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
import dateUtils from "../plugins/date-utils";
import moment from "moment";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
export default {
  name: "IntentGroup",
  inject: [
    "flagNav",
    "FontColorTitle",
    "SubNavbarBackGround",
    "Username",
    "RoleId"
  ],
  components: {},
  mixins: [checkPermissionTwo],
  data: () => ({
    showDeleteSuccess: false,
    deleteSuccessMessage: '',
    _deleteToastTimer: null,
    showDeleteDialog: false,
    loadingTable: false,
    today: null,
    searchName: null,
    AddIntentGroup: false,
    EditIntentGroup: false,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    dataTable: [],
    itemsPerPage: 10,
    searchTotalTable: 0,
    totalTable: 0,
    dialog: false,
    DDIntentSession: [],
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    rules: {
      required: (value) => !!value || "Required.",
    },
    GroupIntent: {
      IntentGroupID: null,
      Name: null,
      IntentSession: null,
    },
    sortBy: [],
    sortDesc: [],
    isFirst: true,
    isSearch: false,
  }),
  computed: {
    headers() {
      return [
        { title: this.$t("no"), align: "left", sortable: false, width: "10%" },
        {
          title: "Intent Group Name",
          value: "Name",
          align: "left",
          sortable: true,
          width: "20%",
          fontWeight: 700,
        },
        {
          title: "Intent Session",
          value: "IntentSessionName",
          align: "left",
          sortable: false,
          width: "35%",
          class: "wrap-text",
        },
        {
          title: "Created By",
          value: "CreateBy",
          align: "left",
          sortable: true,
          width: "15%",
        },
        {
          title: this.$t("manage"),
          align: "center",
          sortable: false,
          width: "15%",
        },
      ];
    },
    rangeStart() {
      if (!this.searchTotalTable) return 0;
      return (this.options.page - 1) * this.options.itemsPerPage + 1;
    },
    rangeEnd() {
      if (!this.searchTotalTable) return 0;
      return Math.min(this.options.page * this.options.itemsPerPage, this.searchTotalTable);
    },
    totalPages() {
      return this.searchTotalTable;
    },
  },
  watch: {
    options: {
    handler() {
      this.Get();
    },
    deep: true,
    immediate: true,
  },
  },
  methods: {
    openDeleteDialog(item) {
      this.item = item;
      this.showDeleteDialog = true;
    },
    closeDeleteDialog() {
      if (this.deleting) return;
      this.showDeleteDialog = false;
      this.item = null;
    },
    btnDisableDelete(item) {
      if ((this.RoleId == 2 || this.RoleId == 6) && item.createBy != this.Username) {
        return true;
      }
      return false;
    },
    Search() {
      this.options.page = 1;
      this.Get();
    },
    onSearchInput() {
      this.options.page = 1;
      this.Get();
    },
    clearSearch() {
      this.searchName = null;
      this.options.page = 1;
      this.Get();
    },
    Get() {
      let self = this;
      // self.dialog = true;
      self.loadingTable = true;
      
      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        DataName: self.searchName,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableIntentGroup(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          if (self.isFirst) {
            this.GetDDIntentSession();
          }
          // self.dialog = false;
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          // self.dialog = false;
          self.loadingTable = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    async Save() {
      let self = this;
      try {
        if (
          self.GroupIntent.Name == "" ||
          self.GroupIntent.Name == null ||
          self.GroupIntent.IntentSession == "" ||
          self.GroupIntent.IntentSession == null
        ) {
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: self.$t("warningFillAll"),
            showConfirmButton: false,
            timer: 1800,
          });
          return;
        }
        self.dialog = true;
        if (self.AddIntentGroup) {
          await self.$call.CreateIntentGroup(
            self.GroupIntent,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.totalTable = self.totalTable + 1;
                self.Get();
                self.AddIntentGroup = false;
              } else if (dataResponse.status == 3) {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.AddIntentGroup = false;
              console.error(errorResource);
            }
          );
        } else if (self.EditIntentGroup) {
          await self.$call.UpdateIntentGroup(
            self.GroupIntent,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.Get();
                self.EditIntentGroup = false;
              } else if (dataResponse.status == 3) {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Editdialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Add() {
      let self = this;
      self.GroupIntent.IntentGroupID = null;
      self.GroupIntent.Name = null;
      self.GroupIntent.IntentSession = null;
      // self.AddIntentGroup = true;
      self.$router.push({
        name: "IntentSession",
        query: {
          id: null,
        },
      });
    },
    // Edit(item) {
    //   let self = this;
    //   self.EditIntentGroup = true;
    //   self.GroupIntent.IntentGroupID = item.intentGroupID;
    //   self.GroupIntent.Name = item.name;
    //   self.GroupIntent.IntentSession = item.intentSession;
    // },
    Edit(item) {
      let self = this;
      self.$router.push({
        name: "IntentSession",
        query: {
          id: item.intentGroupID,
        },
      });
    },
    Delete(id) {
      this.dialog = true;
      this.deleting = true;
      this.$call.DeleteIntentGroup(
        { IntentGroupID: id },
        (dataResponse) => {
          this.dialog = false;
          this.deleting = false;
          this.showDeleteDialog = false;
          if (dataResponse.status == 0) {
            // Show fade-slide toast
            this.deleteSuccessMessage = "Intent Group has been deleted !";
            this.showDeleteSuccess = true;
            clearTimeout(this._deleteToastTimer);
            this._deleteToastTimer = setTimeout(() => {
              this.showDeleteSuccess = false;
            }, 3000);
            this.Get();
          } else if (dataResponse.status == 1) {
            this.$swal.fire({
              icon: "error",
              title: dataResponse.message,
              showConfirmButton: true,
              confirmButtonText: this.$t("gotIt"),
              confirmButtonColor: "#d33",
            });
          }
        },
        (errorResource) => {
          this.dialog = false;
          this.deleting = false;
          console.error(errorResource);
        }
      );
    },
    // Delete(id) {
    //   let self = this;
    //   try {
    //     self.$swal
    //       .fire({
    //         title: this.$t("ConfirmDeletion"),
    //         text: this.$t("confirmDeletionIntentGroup"),
    //         icon: "warning",
    //         showCancelButton: true,
    //         confirmButtonColor: "#3085d6",
    //         cancelButtonColor: "#d33",
    //         confirmButtonText: this.$t("confirm"),
    //         cancelButtonText: this.$t("cancel"),
    //         reverseButtons: false,
    //       })
    //       .then((result) => {
    //         if (result.isConfirmed) {
    //           self.dialog = true;
    //           self.$call.DeleteIntentGroup(
    //             { IntentGroupID: id },
    //             (dataResponse) => {
    //               self.dialog = false;
    //               if (dataResponse.status == 0) {
    //                 self.$swal.fire({
    //                   icon: "success",
    //                   title: dataResponse.message,
    //                   showConfirmButton: false,
    //                   timer: 1500,
    //                 });
    //                 self.Get();
    //               }else if (dataResponse.status == 1) {
    //                 self.$swal.fire({
    //                   icon: "error",
    //                   title: dataResponse.message,
    //                   showConfirmButton: true,
    //                   confirmButtonText: this.$t("gotIt"),
    //                   confirmButtonColor: "#d33",
    //                 });
    //               }
    //             },
    //             (errorResource) => {
    //               self.dialog = false;
    //               console.error(errorResource);
    //             }
    //           );
    //           self.Get();
    //         }
    //       });
    //   } catch (error) {
    //     self.LogTrace(error, "DeleteGroup");
    //   }
    // },
    beforeUnmount() {
      clearTimeout(this._deleteToastTimer);
    },
    convertDateToString(date, seperator = "/") {
      return dateUtils.getStringWithTimeFromDate(
        moment(date).toDate(),
        seperator
      );
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!
      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      this.today = dd + "/" + mm + "/" + yyyy;
    },
    GetDDIntentSession() {
      let self = this;
      self.loadingTable = true;
      self.$call.DDIntentSession(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDIntentSession = dataResponse.data;
          } else {
            self.DDIntentSession = [];
          }
          self.loadingTable = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          console.error(errorResource);
        }
      );
    },
    substring(text) {
      if (text != null) {
        if (text.length > 50) {
          return text.substring(0, 50) + "...";
        }
        return text;
      }
      return text;
    },
  },
  mounted() {
    this.GetDate();
    this.Get();
    
  },
};
</script>
<style scoped>
.success-toast {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(100deg, #2ABF56 0%, #135928 100%) !important;
  color: #ffffff;
  padding: 10px 24px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  z-index: 2100;
  width: 50%;
  max-width: 900px;
  min-width: 320px;
  justify-content: center;
  padding: 12px;
  border: 1px solid #ffffff;
  gap: 20px;
  margin-top: 140px;
}
.delete-dialog-card {
  border-radius: 12px !important;
}
.card-dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
}
.dialog-title {
  margin-top: 8px;
  font-size: 16px;
  color: #C30000;
}
.body-text {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  color: #171717;
}
.cancel-btn {
  border: 1px solid #949AA8;
  border-radius: 12px;
  height: 40px;
  padding: 4px 16px;
}
.delete-confirm-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px !important;
  width: 120px;
  background: #C30000;
}
.products-header-button {
  display: flex;
  flex-direction: row;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  border-radius: 12px;
  width: 108px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 12px;
  margin-right: 16px;
}
.products-header-button:hover {
  background: linear-gradient(100deg, #F36243 0%, #FF8E7A 100%) !important;
}
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}

.items-select :deep(.v-field) { 
  border-radius: 14px;
  margin-right: 6px;
}
.small-select :deep(.v-field) {
  min-height: 30px;
  height: 36px;
  padding: 0 4px;
}
.small-select :deep(.v-field__input) { 
  min-height: 30px; 
}
.items-select :deep(.v-field__input),
.items-select :deep(.v-select__selection-text),
.items-select :deep(.v-list-item-title) {
  font-size: 14px !important;
}
.dropdown-icon { 
  width: 20px;
  height: 20px;
  transition: transform .2s ease;
  margin-right: 4px;
}
.small-select.v-select--active-menu .dropdown-icon { 
  transform: rotate(180deg);
}
.search-input {
  max-width: 280px;
  background: white;
  border: 1px solid #C9C9C9;
  border-radius: 12px;
}
.search-input :deep(.v-field__field) {
  align-items: center;
}
.search-input :deep(input) {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  line-height: 20px;
  min-height: 40px;
  display: flex;
  align-items: center;
  font-size: 13px;
}
.search-icon {
  margin-left: 12px;
  margin-top: -4px;
  height: 18px;
}
.card2 {
  border: 1px solid #DCDCDC;
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
  box-shadow: none;
}

.card {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  height: 90vh;
  overflow: auto;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
/* 
.v-tooltip {
  background-color: #333;
  color: #fff;
} */
.AddColumn:hover {
  background-color: #1976d2 !important;
  color: white !important;
}
:deep(.UploadFile .NoDragDrop button.v-btn) {
  margin: 0px !important;
}
.wrap-text {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  /* transform: translateY(-1px); */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

:deep(.v-data-table.sorting-loading) {
  position: relative;
  pointer-events: none;
}

:deep(.v-data-table.sorting-loading::after) {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

/* Enhanced Sorting Indicators */
:deep(.v-data-table-header th.sortable) {
  cursor: pointer;
  transition: all 0.2s ease;
}

:deep(.v-data-table-header th.sortable:hover) {
  background: rgba(25, 118, 210, 0.05);
  color: #1976d2 !important;
}

:deep(.v-data-table-header th.sorted) {
  background: rgba(25, 118, 210, 0.1);
  color: #1976d2 !important;
}

/* Sorting Animation */
:deep(.v-data-table tbody) {
  transition: opacity 0.3s ease;
}

:deep(.v-data-table.sorting-loading tbody) {
  opacity: 0.6;
}
</style>
